import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";
export const sizes = ["xs", "s", "m", "l", "xl", ""];
export const sizeValues = [40, 60, 80, 120, 200];

export const imageProps = buildProps({
  src: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    values: sizes,
    default: "",
  },
  fit: {
    type: String,
    values: ["", "contain", "cover", "fill", "none", "scale-down"],
    default: "",
  },
  lazy: {
    type: Boolean,
    default: false,
  },
  scrollContainer: {
    type: definePropType<string | HTMLElement | undefined>([String, Object]),
  },
} as const);

export type ImageProps = ExtractPropTypes<typeof imageProps>;
